import Breadcrumb from '../../components/Breadcrumbs/Breadcrumb';
import StudentsTable from '../../components/Students/StudentsTable';



const Students = () => {
  // const { isPending, isError, data, error } = useQuery({
  //   queryKey: ['todos'],
  //   queryFn: () => {},
  // })

  // if (isPending) {
  //   return <span>Loading...</span>
  // }

  // if (isError) {
  //   return <span>Error: {error.message}</span>
  // }
  

  return (
    <>
      <Breadcrumb pageName="Student List" />

      <div className="flex flex-col gap-10">
        <StudentsTable />
      </div>
    </>
  )
}

export default Students